module.exports = __webpack_public_path__ + "img/26.db035d53.png";